import { connect, type DispatchProp } from "react-redux";
import ConnectedAppLayout from "../AppLayout";
import { Skeleton } from "antd";
import type { Materials, Services } from "../generated-axios-client";
import type { IntlShape } from "@formatjs/intl";
import { ServiceViewRender } from "./ServiceViewRender";
import type { RootState } from "../store";

type ServiceViewProps = {
  intl: IntlShape;
  service: Services | null;
  materialsList: Materials[];
};

const ServiceView = (props: ServiceViewProps & DispatchProp) => {
  const { intl, service, materialsList, dispatch } = props;

  if (!service) {
    return <Skeleton active />;
  }

  return (
    <ConnectedAppLayout>
      <ServiceViewRender
        intl={intl}
        service={service}
        materialsList={materialsList}
        dispatch={dispatch}
      />
    </ConnectedAppLayout>
  );
};

export const ConnectedServiceViewPage = connect((state: RootState) => ({
  intl: state.intl.datetimeIntl,
  service: state.services.service,
  materialsList: state.materials.list.results ?? [],
}))(ServiceView);

export default ConnectedServiceViewPage;
